import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import clsx from 'clsx'
import editImg from '../../assets/web/edit.png'
import deleteImg from '../../assets/web/delete.png'

const Item = styled.div`
  border-bottom: 1px solid #dbdfea;
  &:hover {
    background: #f5f6fa;
  }
  ${tw`transition duration-200 ease-in-out transform cursor-pointer`}

  .orgs {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`

const RoleItem = function ({
  row,
  style,
  showEditRoleModal,
  updateCurrentRole,
  deleteRole,
}) {
  const renderInfo = function (cell, column) {
    const role = cell.row.original
    if (column.id === 'operate') {
      return (
        <div className="flex justify-center items-center text-sm">
          {role.userCount === 0 && (
            <div
              className="quit flex items-center mr-6"
              title="编辑"
              onClick={() => {
                updateCurrentRole(cell.row.original)
                showEditRoleModal()
              }}
            >
              <img alt="" className="w-3.5 h-3.5" src={editImg} />
            </div>
          )}

          {role.userCount === 0 && (
            <div
              className="quit flex items-center"
              title="删除"
              onClick={() => {
                deleteRole(role)
              }}
            >
              <img alt="" className="w-3.5 h-3.5" src={deleteImg} />
            </div>
          )}
        </div>
      )
    }
    // 控制角色组织宽度
    if (column.id === 'orgs') {
      return (
        <p className="w-11/12 orgs" title={role.orgs}>
          {role.orgs}
        </p>
      )
    }
    return cell.render('Cell')
  }

  return (
    <Item
      {...row.getRowProps({ style })}
      className="flex pl-4"
      key={row.original.id}
    >
      {row.cells.map((cell) => {
        const { column } = cell
        return (
          <div
            {...cell.getCellProps()}
            key={column.id}
            className={clsx([
              {
                'w-32 lg:w-1/4':
                  column.id !== 'selection' && column.id !== 'orgs',
                'w-10': column.id === 'selection',
                'w-1/3': column.id === 'orgs',
              },
              'flex items-center p-2',
            ])}
          >
            {renderInfo(cell, column)}
          </div>
        )
      })}
    </Item>
  )
}
export default RoleItem
